import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import BoardForm from './BoardForm.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kanban'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_kanban_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'new',
          name: 'settings_kanban_new',
          meta: {
            permissions: ['administrator'],
          },
          component: BoardForm,
        },
        {
          path: ':boardId',
          name: 'settings_kanban_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: BoardForm,
          props: route => ({ boardId: Number(route.params.boardId) }),
        },
      ],
    },
  ],
};
